"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _apiPayments = _interopRequireDefault(require("../../../../api/api-payments"));
var _form = require("../forms/form");
var _toggleButton = require("../buttons/toggle-button");
var _apiEnv = require("../../../../api/api-env");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var RecipientForm = /*#__PURE__*/function (_React$Component) {
  _inherits(RecipientForm, _React$Component);
  function RecipientForm(props) {
    var _this;
    _classCallCheck(this, RecipientForm);
    _this = _callSuper(this, RecipientForm, [props]);
    _this.state = {
      accountType: 'company',
      name: '',
      errorMessage: ''
    };
    _this.updateAccountType = _this.updateAccountType.bind(_assertThisInitialized(_this));
    _this.accountTypeToggle = _this.accountTypeToggle.bind(_assertThisInitialized(_this));
    _this.finalCallback = _this.finalCallback.bind(_assertThisInitialized(_this));
    _this.addPayoutToProfile = _this.addPayoutToProfile.bind(_assertThisInitialized(_this));
    _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(RecipientForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      (0, _apiEnv.getWebEnv)(function (env) {
        Stripe.setPublishableKey(env.stripe.stripe_public_key);
      });
    }
  }, {
    key: "updateAccountType",
    value: function updateAccountType(value) {
      this.setState({
        accountType: value
      });
    }
  }, {
    key: "accountTypeToggle",
    value: function accountTypeToggle() {
      return /*#__PURE__*/_react.default.createElement(_toggleButton.Toggle, {
        onLabel: this.props.intl.formatMessage({
          id: 'shared_components.recipient_form.account_type_on_label',
          defaultMessage: 'Business'
        }),
        offLabel: this.props.intl.formatMessage({
          id: 'shared_components.recipient_form.account_type_off_label',
          defaultMessage: 'Personal'
        }),
        onValue: "company",
        offValue: "individual",
        selectedValue: "company",
        changeCallback: this.updateAccountType,
        errorMsg: this.props.intl.formatMessage({
          id: 'shared_components.recipient_form.account_type_error',
          defaultMessage: 'Please select your account type'
        }),
        ref: "bank-account-toggle",
        label: this.props.intl.formatMessage({
          id: 'shared_components.recipient_form.account_type_label',
          defaultMessage: 'Select Account Type'
        })
      });
    }
  }, {
    key: "finalCallback",
    value: function finalCallback(hasError) {
      if (!hasError) {
        this.props.callback();
      }
    }
  }, {
    key: "addPayoutToProfile",
    value: function addPayoutToProfile(token, callback) {
      var _this2 = this;
      var payload = {
        bank_account_token: token,
        legal_name: $('#account-holder-name').val(),
        type: this.state.accountType == 'company' ? 'corporation' : 'individual'
      };
      _apiPayments.default.updateBank(PSSessions.Cookies('PSUser'), PSSessions.Cookies('PSAccess'), payload, function (response) {
        if (200 !== response.statusCode) {
          _this2.setState({
            errorMessage: _this2.props.intl.formatMessage({
              id: 'shared_components.recipient_form.payout_error',
              defaultMessage: 'Something went wrong. Please try again.'
            })
          });
          callback(true);
        } else {
          callback();
        }
      });
    }
  }, {
    key: "submitForm",
    value: function submitForm(form, callback) {
      var _this3 = this;
      _apiPayments.default.createStripeToken('ach-form', 'bank-account', function (status, response) {
        if (response.error) {
          _this3.setState({
            errorMessage: response.error.message
          });
          callback(true);
        } else {
          _this3.addPayoutToProfile(response.id, callback);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isIndividual = 'individual' === this.state.accountType;
      /* values below related to bank account holder */
      var nameFieldLabel = isIndividual ? this.props.intl.formatMessage({
        id: 'shared_components.recipient_form.name_label',
        defaultMessage: 'Name'
      }) : this.props.intl.formatMessage({
        id: 'shared_components.recipient_form.organization_label',
        defaultMessage: 'Organization'
      });
      var nameInputPlaceholder = isIndividual ? this.props.intl.formatMessage({
        id: 'shared_components.recipient_form.name_input_placeholder',
        defaultMessage: 'Full Legal Name'
      }) : this.props.intl.formatMessage({
        id: 'shared_components.recipient_form.business_input_placeholder',
        defaultMessage: 'Legal Business Name'
      });
      var nameMoreInfo = isIndividual ? this.props.intl.formatMessage({
        id: 'shared_components.recipient_form.name_more_info',
        defaultMessage: 'Your legal name will be used to verify your identity and must match what is on record when you submit your SSN.'
      }) : this.props.intl.formatMessage({
        id: 'shared_components.recipient_form.business_more_info',
        defaultMessage: 'Your legal business name will be used to verify your company identity and must match what is on record when you submit your EIN.'
      });

      /*
        account type toggle us where user selects account type, but value in form
        is populated by state and ready by Stripe from account_holder input field
      */
      var formInputs = [{
        custom: this.accountTypeToggle
      }, {
        inputFieldName: 'hidden_account_type',
        dataAttributes: {
          'data-stripe': 'account_holder_type'
        },
        hideRequired: true,
        setVal: this.state.accountType
      }, {
        elementID: 'account-holder-name',
        inputFieldName: 'account_holder',
        optional: false,
        dataAttributes: {
          'data-stripe': 'account_holder_name'
        },
        label: nameFieldLabel,
        labelSize: 'col-xs-12',
        placeholder: nameInputPlaceholder,
        helperText: nameMoreInfo
      }, {
        inputFieldName: 'account_number',
        optional: false,
        colSize: 'col-xs-6 half-padding-right',
        labelSize: 'col-xs-12',
        dataAttributes: {
          'data-stripe': 'account_number'
        }
      }, {
        inputFieldName: 'routing_number',
        optional: false,
        colSize: 'col-xs-6 half-padding-left',
        labelSize: 'col-xs-12',
        dataAttributes: {
          'data-stripe': 'routing_number'
        }
      }, {
        inputFieldName: 'hidden_country_code',
        elementID: 'month',
        dataAttributes: {
          'data-stripe': 'country'
        },
        defaultVal: 'US'
      }];
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginLeft: 45,
          marginRight: 45
        }
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "heading text-center"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.recipient_form.update_bank_account",
        defaultMessage: "Update your bank account"
      })), /*#__PURE__*/_react.default.createElement("p", {
        className: "form-standard"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.recipient_form.update_bank_account_description",
        defaultMessage: "Please enter your banking information to approve this booking. We\u2019ll directly deposit all of your payouts into your account."
      })), /*#__PURE__*/_react.default.createElement(_form.FormBuilder, {
        formname: "transactableBankAccount",
        id: "ach-form",
        formStyle: "standard",
        formInputs: formInputs,
        errorText: this.state.errorMessage,
        submitAction: this.submitForm,
        submitCallback: this.finalCallback,
        buttonText: this.props.intl.formatMessage({
          id: 'shared_components.recipient_form.button_update',
          defaultMessage: 'Update'
        })
      }));
    }
  }]);
  return RecipientForm;
}(_react.default.Component);
exports.RecipientForm = (0, _reactIntl.injectIntl)(RecipientForm);